var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._l((_vm.games),function(game){return _c('div',{key:game.roleId},[_c('GameListItem',{attrs:{"game":game}})],1)}),_c('div',{staticClass:"add-div"},[(_vm.admin)?_c('router-link',{attrs:{"to":"/createGame"}},[_c('span',{staticClass:"material-icons"},[_vm._v("add")])]):_vm._e()],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }